import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    d="m10.707 5.2071c0.3905-0.39053 0.3905-1.0237 0-1.4142-0.3905-0.39052-1.0237-0.39052-1.4142 0l-3.7929 3.7929-1.7929-1.7929c-0.39053-0.39052-1.0237-0.39052-1.4142 0-0.39052 0.39053-0.39052 1.0237 0 1.4142l3.2071 3.2071 5.2071-5.2071zm2.2929 2.7929c0-0.55228 0.4477-1 1-1h7c0.5523 0 1 0.44772 1 1s-0.4477 1-1 1h-7c-0.5523 0-1-0.44772-1-1zm9 9c0-0.5523-0.4477-1-1-1h-7c-0.5523 0-1 0.4477-1 1s0.4477 1 1 1h7c0.5523 0 1-0.4477 1-1zm-18-4c-1.1046 0-2 0.8954-2 2v4c0 1.1046 0.89543 2 2 2h4c1.1046 0 2-0.8954 2-2v-4c0-1.1046-0.89543-2-2-2h-4zm4 2h-4v4h4v-4z"
    clipRule="evenodd"
    fillRule="evenodd"
  />
);

const smallIcon = [
  <path
    key="1"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.89951 3.10054C7.12016 3.32119 7.12016 3.67893 6.89951 3.89957L3.5 7.29909L1.60048 5.39957C1.37984 5.17893 1.37984 4.82119 1.60048 4.60054C1.82113 4.3799 2.17887 4.3799 2.39951 4.60054L3.5 5.70103L6.10048 3.10054C6.32113 2.8799 6.67887 2.8799 6.89951 3.10054ZM8.435 5.50006C8.435 5.18802 8.68796 4.93506 9 4.93506H14C14.312 4.93506 14.565 5.18802 14.565 5.50006C14.565 5.8121 14.312 6.06506 14 6.06506H9C8.68796 6.06506 8.435 5.8121 8.435 5.50006ZM8.435 11.5001C8.435 11.188 8.68796 10.9351 9 10.9351H14C14.312 10.9351 14.565 11.188 14.565 11.5001C14.565 11.8121 14.312 12.0651 14 12.0651H9C8.68796 12.0651 8.435 11.8121 8.435 11.5001Z"
  />,
  <path
    key="2"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.13 10.1301V12.8701H5.87V10.1301H3.13ZM3 9.00006H6C6.55228 9.00006 7 9.44777 7 10.0001V13.0001C7 13.5523 6.55228 14.0001 6 14.0001H3C2.44771 14.0001 2 13.5523 2 13.0001V10.0001C2 9.44777 2.44771 9.00006 3 9.00006Z"
  />,
];

export const ListIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="List" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
